import { Observable, of } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import { $isLogged } from 'services/SessionService'

export default function loggedRequestSwitcher<Logged, Prepay> (
  loggedRequest: () => Observable<Logged>,
  prepayRequest: () => Observable<Prepay>
): Observable<number | Logged | Prepay> {
  return $isLogged.pipe(
    switchMap(isLoggedObj => {
      if (isLoggedObj === RESPONSE_PENDING) {
        return of(RESPONSE_PENDING)
      }
      const { isLogged } = isLoggedObj
      return isLogged === true ? loggedRequest() : prepayRequest()
    })
  )
}
